import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { statusTone, statusLabel } from '../../../utils/sentEmails';

// Local time, in the Loyalty tables' 'DD MMM YYYY · HH:mm' shape. The exact UTC
// instant stays one hover away in the cell's title.
const formatSentAt = (value) => {
  if (!value) return '—';
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format('DD MMM YYYY · HH:mm') : String(value);
};

const SentEmailsTable = ({
  items, onOpen, hasMore, loadingMore, onLoadMore,
}) => {
  const handleRowKeyDown = (event, row) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onOpen(row);
    }
  };

  return (
    <div className="ps-card">
      <table className="ps-table">
        <thead>
          <tr>
            <th style={{ width: '16%' }}>Sent at</th>
            <th style={{ width: '24%' }}>To</th>
            <th>Subject</th>
            <th style={{ width: '14%' }}>Kind</th>
            <th style={{ width: '12%' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {items.map(row => (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <tr
              key={row.messageId}
              tabIndex={0}
              aria-label={`Open email to ${row.recipient || 'unknown recipient'}: ${row.subject || 'no subject'}`}
              onClick={() => onOpen(row)}
              onKeyDown={event => handleRowKeyDown(event, row)}
            >
              <td className="when" title={row.sentAt || ''}>{formatSentAt(row.sentAt)}</td>
              <td className="to">{row.recipient || '—'}</td>
              <td className="subject">
                {row.subject
                  ? <span className="clip" title={row.subject}>{row.subject}</span>
                  : <span className="none">(no subject)</span>}
              </td>
              <td>
                <span className={`kind ${row.dataClass || ''}`} title={row.dataClass || undefined}>{row.kind || '—'}</span>
              </td>
              <td>
                <span className={`chip chip--${statusTone(row.status)}`}>{statusLabel(row.status)}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="tablefoot">
        <span>{`${items.length} shown${hasMore ? ' · more available' : ' · end of results'}`}</span>
        {hasMore ? (
          <button type="button" className="btn ghost tiny" onClick={onLoadMore} disabled={loadingMore}>
            {loadingMore ? 'Loading…' : 'Load more'}
          </button>
        ) : null}
      </div>
    </div>
  );
};

SentEmailsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    messageId: PropTypes.string.isRequired,
    sentAt: PropTypes.string,
    recipient: PropTypes.string,
    subject: PropTypes.string,
    kind: PropTypes.string,
    dataClass: PropTypes.string,
    status: PropTypes.string,
  })).isRequired,
  onOpen: PropTypes.func.isRequired,
  hasMore: PropTypes.bool,
  loadingMore: PropTypes.bool,
  onLoadMore: PropTypes.func.isRequired,
};

SentEmailsTable.defaultProps = {
  hasMore: false,
  loadingMore: false,
};

export { formatSentAt };
export default SentEmailsTable;
